/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {EventEmitter, Injectable} from '@angular/core';
import {AlertNotification} from './alert.notification.model';

@Injectable({
    providedIn: 'root'
})
export class AlertNotificationService {
    public notificationEventEmitter = new EventEmitter<AlertNotification>();
}
